import { m, useReducedMotion } from 'motion/react'
import type { PropsWithChildren } from 'react'

// Scroll-triggered fade/rise, the "big type reveals as you scroll" pattern
// from every reference site Leo sent. useReducedMotion is checked explicitly
// -- whileInView doesn't auto-disable itself for that preference -- and a
// reduced-motion visitor just gets the content, no animation.
export function Reveal({
  children,
  delay = 0,
  className = '',
}: PropsWithChildren<{ delay?: number; className?: string }>) {
  const reduceMotion = useReducedMotion()

  if (reduceMotion) return <div className={className}>{children}</div>

  return (
    <m.div
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </m.div>
  )
}
